export class Embed {
  title: string;
  code: string;
  description: string;
  // thumbnail: string;

  constructor(embed?: Embed) {
    this.title = (embed && embed.title) ? embed.title : '';
    this.code = (embed && embed.code) ? embed.code : '';
    this.description = (embed && embed.description) ? embed.description : '';
    // this.thumbnail = (embed && embed.thumbnail) ? embed.thumbnail : '';
  }

}
